export class StockTransfer {
    constructor(public TID?, public TDT?, public Rmk?, public IScID?, public IScN?, public OScID?, public OScN?, public STDetail?) { }
}